import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { useFormContext } from 'modules/client/common/forms/withdrawalAccountForm';

export const Header = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  return (
    <Stack alignItems="center" spacing={12}>
      <Typography variant="headerBold">
        {t('client.client.withdrawalAccounts.title')}
      </Typography>

      {!readOnly && (
        <Typography align="center" variant="bodyMedium">
          {t('client.client.withdrawalAccounts.subtitle')}
        </Typography>
      )}
    </Stack>
  );
};
